module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n1n3n6r-b0f85dcf41d42322257996127c94bd10.svg";